import { WHATSAPP_NUMBER as _NUMBER } from "../data/products";

export const WHATSAPP_NUMBER = _NUMBER;

// Build a wa.me URL with a prefilled message.
export const buildWhatsAppUrl = (message = "") => {
  const number = WHATSAPP_NUMBER.replace(/[^0-9]/g, "");
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${number}${encoded ? `?text=${encoded}` : ""}`;
};
